/**
 * @author Daniel Aguirre
 * @file constants.js
 * @description MedicalParameter Constants
 */

// Generic actions
export const GET_CLINIC_PHONES_BY_CLINIC_NAME =
  'clinicPhones/GET_CLINIC_PHONES_BY_CLINIC_NAME';
export const GET_ALL_CLINIC_PHONES = 'clinicPhones/GET_ALL_CLINIC_PHONES';
export const GET_CLINIC_PHONES_BY_ID = 'clinicPhones/GET_CLINIC_PHONES_BY_ID';
export const CREATE_CLINIC_PHONES = 'clinicPhones/CREATE_CLINIC_PHONES';
export const UPDATE_CLINIC_PHONES = 'clinicPhones/UPDATE_CLINIC_PHONES';
export const DELETE_CLINIC_PHONES_BY_ID =
  'clinicPhones/DELETE_MEDICAL_PARAMETER_BY_ID';
